import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'src/components/ui/dialog';
import { WarningCircleIcon } from '@phosphor-icons/react';
import MDButton from 'src/components/md/MDButton';
import { T, Var, useGT } from 'gt-react';
import type { SyncErrorState } from './types';

export interface SyncErrorDialogProps {
  syncErrorState: SyncErrorState;
  onClose: () => void;
}

export function SyncErrorDialog({
  syncErrorState,
  onClose,
}: SyncErrorDialogProps) {
  const gt = useGT();
  const { isOpen, message, erpSystemName } = syncErrorState;

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(v) => {
        if (!v) onClose();
      }}
    >
      <DialogContent className="max-w-sm border-t-4 border-t-red-500 rounded">
        <DialogHeader>
          <DialogTitle>
            <div className="flex items-center">
              <WarningCircleIcon size={24} className="mr-1 text-error-main" />
              <span className="text-red-600 font-medium">
                {erpSystemName ? (
                  <T context="error dialog title when ERP sync fails">
                    Failed to Sync to <Var>{erpSystemName}</Var>
                  </T>
                ) : (
                  <T context="error dialog title when ERP sync fails, unknown system">
                    Failed to Sync to ERP
                  </T>
                )}
              </span>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-1 rounded bg-red-500/[0.08] border border-red-500/20 p-4">
          <p className="whitespace-pre-wrap break-words font-mono text-[0.8rem] leading-relaxed">
            {message}
          </p>
        </div>
        <DialogFooter>
          <MDButton variant="text" color="error" onClick={onClose}>
            {gt('Close', { context: 'dismiss error dialog' })}
          </MDButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
